var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLegal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5376 1.99687L17.3676 4.82687C18.1476 5.60687 18.1476 6.87687 17.3676 7.65687L15.9476 9.07687L10.2976 3.41687L11.7076 2.00687C12.4876 1.21687 13.7576 1.21687 14.5376 1.99687ZM8.87762 4.82687L6.04762 7.65687L18.7776 20.3869C19.5576 21.1669 20.8276 21.1669 21.6076 20.3869C22.3876 19.6069 22.3876 18.3369 21.6076 17.5569L8.87762 4.82687ZM12.8076 20.5869H2.80762C2.25762 20.5869 1.80762 21.0369 1.80762 21.5869C1.80762 22.1369 2.25762 22.5869 2.80762 22.5869H12.8076C13.3576 22.5869 13.8076 22.1369 13.8076 21.5869C13.8076 21.0369 13.3576 20.5869 12.8076 20.5869ZM10.2976 14.7269L4.63762 9.06687L3.22762 10.4769C2.44762 11.2569 2.44762 12.5269 3.22762 13.3069L6.05762 16.1369C6.83762 16.9169 8.10762 16.9169 8.88762 16.1369L10.2976 14.7269Z",
    fill: "#777777",
    strokeWidth: "0.1px"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegal);
export default __webpack_public_path__ + "static/media/legal.85757f9c.svg";
export { ForwardRef as ReactComponent };